import { post } from '../axios'

// 员工信息查询
export function staff_list_post(map, option) {
  return post(`${process.env.VUE_APP_STAFF}/staff/list`, map, option).then(
    response => response
  )
}

// 员工信息查询
export function staff_list_config_post(map, option) {
  return post(
    `${process.env.VUE_APP_STAFF}/staff/list-config`,
    map,
    option
  ).then(response => response)
}

// 员工所有信息查询
export function staff_list_config_all_post(map, option) {
  return post(
    `${process.env.VUE_APP_STAFF}/staff/list-config-all`,
    map,
    option
  ).then(response => response)
}

// 员工信息更新
export function staff_update_post(map, option) {
  return post(`${process.env.VUE_APP_STAFF}/staff/update`, map, option).then(
    response => response
  )
}

// 组织架构查询
export function staff_list_depart_post(map, option) {
  return post(
    `${process.env.VUE_APP_STAFF}/staff/list-depart`,
    map,
    option
  ).then(response => response)
}
